import {
  TOGGLE_PLAYER,
  RECEIVE_NOW_PLAYING,
  REQUEST_TITLE,
  CHANGE_PLAYER_STATE,
  SET_NOW_PLAYING,
  ZED_PLAYER_PLAY
} from './actions'

export default function player(
  state = { visible: true, nowPlaying: { title: null, image: null, url: null }, playerState: 'paused', event: { src: null, position: null} }, action
) {
  switch(action.type) {
    case ZED_PLAYER_PLAY:
      return { ...state, event: { src: action.src, position: action.position } }
    case TOGGLE_PLAYER:
      return Object.assign({}, state, {
        visible: (action.visible ? action.visible : !state.visible)
      })
    case SET_NOW_PLAYING:
      return Object.assign({}, state, {
        nowPlaying: {
          title: action.title,
          image: action.image,
          url: action.url
        }
      })
    case RECEIVE_NOW_PLAYING:
    case REQUEST_TITLE:
    case CHANGE_PLAYER_STATE:
    default:
      return state
  }
}
